import React from 'react';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import Tooltip from '@src/components/Tooltip';
import { StyledInsert } from './index.style';

// Nudge like the track-icon tooltips (see TrackGutter).
const TOOLTIP_POPPER_PROPS = {
  popperOptions: {
    modifiers: [{ name: 'offset', options: { offset: [0, -6] } }],
  },
};

// Mid-lane twin of AppendButton: fills a gap between clips, shown on hover.
// `data-timeline-append` keeps a click from seeking.
const InsertButton = ({ title, left, width, onClick }) => (
  <Tooltip
    arrow
    title={title}
    placement="top"
    PopperProps={TOOLTIP_POPPER_PROPS}
  >
    <StyledInsert
      type="button"
      data-timeline-append
      style={{ left, width }}
      onClick={onClick}
    >
      <AddRoundedIcon />
    </StyledInsert>
  </Tooltip>
);

export default InsertButton;
